<template>
    <svg class="svg-metal" v-html="svgIcon">
    </svg>
</template>

<script setup>
const props = defineProps(['type'])

const headerSvgs = [
    'white', 'yellow', 'rose', 'white_active', 'yellow_active', 'rose_active'
]

const svgIcon = computed(() => {
    if (headerSvgs.includes(props.type)) {
        return `<use xlink:href="/svg/metal.svg#${props.type}"> </use>`
    }
})

</script>

<style scoped></style>
